import { graphql } from 'gatsby'
import { PrismicDocLinkFrag, PrismicExtLinkFrag } from 'fragments/PrismicLink'

import ContactPage from 'views/contact/ContactPage'

export const query = graphql`
  query ContactPageQuery {
    prismic {
      page: contact_page(uid: "contact", lang: "en-us") {
        page_meta_title
        page_meta_description
        page_meta_thumbnail
        contact_page_title
        has_contact_button_cta
        body {
          ... on PRISMIC_Contact_pageBodyInfo_section {
            type
            primary {
              title
              subtitle
              content
              link {
                ...PrismicExtLinkFrag
                ...PrismicDocLinkFrag
              }
              link_text
              content_full_width
            }
          }
          ... on PRISMIC_Contact_pageBodyContact_boxes {
            type
            fields {
              title
              content
            }
          }
        }
      }
    }
  }
`

ContactPage.query = query
ContactPage.fragments = [PrismicDocLinkFrag, PrismicExtLinkFrag]

export default ContactPage
